export default __webpack_public_path__ + "static/media/512size.b3392c37.jpg";